import { render, staticRenderFns } from "./question-preview-modal.vue?vue&type=template&id=3de5244a&scoped=true"
import script from "./question-preview-modal.vue?vue&type=script&lang=js"
export * from "./question-preview-modal.vue?vue&type=script&lang=js"
import style0 from "./question-preview-modal.vue?vue&type=style&index=0&id=3de5244a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de5244a",
  null
  
)

export default component.exports